// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fs-slideshow {
  padding: 40px;
}
@media only screen and (max-width: 991px) {
  .fs-slideshow {
    padding: 20px;
  }
}

.all-learner-maps ::ng-deep .wrapper-learner-map {
  width: 100%;
}
@media (max-width: 991px) {
  .all-learner-maps ::ng-deep .wrapper-learner-map .wrap-all-boxes {
    padding-inline: 20px;
  }
}
.all-learner-maps ::ng-deep .wrapper-learner-map > .wrapper {
  padding: 0;
  margin-inline: auto;
}
::ng-deep .all-learner-maps.presnter-lm {
  padding: 60px 20px;
  clear: both;
  float: left;
  width: 100%;
  display: flex;
  justify-content: center;
}
::ng-deep .all-learner-maps.presnter-lm .wrapper-learner-map--cnc {
  width: 100%;
  display: block;
}
::ng-deep .all-learner-maps.presnter-lm .wrapper-learner-map--cnc .wrap-all-boxes {
  max-width: unset !important;
}
::ng-deep .all-learner-maps.presnter-lm.card-view {
  display: block;
}
::ng-deep .all-learner-maps.presnter-lm__flx {
  display: none;
}
::ng-deep .all-learner-maps.presnter-lm ::ng-deep h4.car-small-heading {
  height: 40px;
  line-height: 23px;
}
::ng-deep .all-learner-maps.presnter-lm .wrapper-content {
  padding: 20px 10px 40px;
  clear: both;
  float: left;
  width: 100%;
}
::ng-deep .all-learner-maps.presnter-lm .wrapper-content--tst {
  width: 100% !important;
}
::ng-deep .all-learner-maps.presnter-lm ::ng-deep.start-work {
  max-width: 180px;
}
::ng-deep .all-learner-maps.presnter-lm ::ng-deep.start-work .product-box {
  padding: 0;
  border: none;
  box-shadow: 10px 10px 10px -3px #676a6c;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .all-learner-maps.presnter-lm ::ng-deep.start-work {
    max-width: unset;
  }
}
::ng-deep .all-learner-maps.presnter-lm ::ng-deep.product-imitation {
  padding: 0px 5px;
  max-height: 130px;
  height: 130px;
  vertical-align: middle;
  text-align: center;
  width: 100%;
  color: #676a6c;
  font-size: 18px;
  font-family: "MuseoSans-300";
  display: flex;
  justify-content: center;
  align-items: center;
}
::ng-deep .all-learner-maps.presnter-lm ::ng-deep.product-imitation .product-desc {
  padding: 0;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .all-learner-maps.presnter-lm ::ng-deep.product-imitation {
    font-size: 16px;
  }
}
::ng-deep .all-learner-maps.presnter-lm .car-small-heading {
  font-family: "Marydale";
  font-size: 18px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .all-learner-maps.presnter-lm .car-small-heading {
    font-size: 15px;
  }
}
@media only screen and (max-width: 991px) {
  ::ng-deep .all-learner-maps.presnter-lm {
    padding: 30px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-learner-maps.presnter-lm {
    padding: 20px 20px 40px;
  }
}
.all-learner-maps.lm-an-cards {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
}
.all-learner-maps.lm-an-cards .product-imitation {
  background-color: #fff;
  color: #676a6c;
}
.all-learner-maps .lm-an-cards__print {
  position: absolute;
  right: 16px;
  top: -35px;
}
@media (max-width: 991px) {
  .all-learner-maps .lm-an-cards__print {
    right: 20px;
  }
}
.all-learner-maps .car-small-heading {
  color: #fff;
}
.all-learner-maps .practioner-dash-wrap--ss {
  background: #F1F1F2;
  border-radius: 6px;
  color: #fff;
  padding: 30px;
}
.all-learner-maps ::ng-deep.start-work__cell .product-imitation {
  background-color: #fff;
  color: #676a6c;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.lm-slide-view {
  padding-top: 20px;
}

.presnter-lm {
  display: block;
}
.presnter-lm__flx {
  display: none;
}
.presnter-lm .map-heading {
  margin-top: 0;
}
.presnter-lm .wrap-all-boxes {
  display: block;
  max-width: 710px;
  margin: 0 auto 50px;
}
.presnter-lm .wrap-all-boxes--ccltst {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/fs-slideshow/fs-slideshow.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;AAAF;AAEE;EAHF;IAII,aAAA;EACF;AACF;;AAMI;EACE,WAAA;AAHN;AASQ;EAJF;IAKI,oBAAA;EANR;AACF;AASM;EACE,UAAA;EAEA,mBAAA;AARR;AAcE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAZJ;AAkBM;EACE,WAAA;EACA,cAAA;AAhBR;AAkBQ;EACE,2BAAA;AAhBV;AAqBI;EACE,cAAA;AAnBN;AAsBI;EACE,aAAA;AApBN;AAuBI;EACE,YAAA;EACA,iBAAA;AArBN;AAwBI;EACE,uBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AAtBN;AAwBM;EACE,sBAAA;AAtBR;AA0BI;EACE,gBAAA;AAxBN;AA0BM;EACE,UAAA;EACA,YAAA;EACA,uCAAA;AAxBR;AA2BM;EATF;IAUI,gBAAA;EAxBN;AACF;AA2BI;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAzBN;AA2BM;EACE,UAAA;AAzBR;AA4BM;EAlBF;IAmBI,eAAA;EAzBN;AACF;AA4BI;EACE,uBAAA;EACA,eAAA;AA1BN;AA4BM;EAJF;IAKI,eAAA;EAzBN;AACF;AA4BI;EA5FF;IA6FI,aAAA;EAzBJ;AACF;AA2BI;EAhGF;IAiGI,uBAAA;EAxBJ;AACF;AA2BE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAzBJ;AA2BI;EACE,sBAAA;EACA,cAAA;AAzBN;AA6BE;EACE,kBAAA;EACA,WAAA;EAEA,UAAA;AA5BJ;AA8BI;EANF;IAOI,WAAA;EA3BJ;AACF;AA8BE;EACE,WAAA;AA5BJ;AA+BE;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AA7BJ;AAkCI;EACE,sBAAA;EACA,cAAA;AAhCN;;AAsCA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAnCF;;AAsCA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAnCF;;AAsCA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAnCF;;AAuCA;EACE,mCAAA;EACA,UAAA;AApCF;;AAuCA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AApCF;;AAuCA;EACE,mCAAA;EACA,mBAAA;EACA,UAAA;AApCF;;AAuCA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AApCF;;AAuCA;EACE;IACE,UAAA;EApCF;EAuCA;IACE,UAAA;EArCF;EAwCA;IACE,UAAA;EAtCF;AACF;AA0CA;EACE,iBAAA;AAxCF;;AA2CA;EACE,cAAA;AAxCF;AA0CE;EACE,aAAA;AAxCJ;AA2CE;EACE,aAAA;AAzCJ;AA4CE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AA1CJ;AA4CI;EACE,eAAA;AA1CN","sourcesContent":["@import url('https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css');\n\n.fs-slideshow {\n  padding: 40px;\n\n  @media only screen and (max-width:991px) {\n    padding: 20px;\n  }\n}\n\n.all-learner-maps {\n\n  ::ng-deep {\n\n    .wrapper-learner-map {\n      width: 100%;\n\n      .wrap-all-boxes {\n        // width: min(976px , 100%);\n        // padding: 40px;\n\n        @media (max-width: 991px) {\n          padding-inline: 20px;\n        }\n      }\n\n      & > .wrapper {\n        padding: 0;        \n        // width: min(976px , 100%);\n        margin-inline: auto;\n      }\n    }\n    \n  }\n\n  ::ng-deep &.presnter-lm {\n    padding: 60px 20px;\n    clear: both;\n    float: left;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n\n    .wrapper-learner-map {\n\n      \n\n      &--cnc {\n        width: 100%;\n        display: block;\n\n        .wrap-all-boxes {\n          max-width: unset !important;\n        }\n      }\n    }\n\n    &.card-view {\n      display: block;\n    }\n\n    &__flx {\n      display: none;\n    }\n\n    ::ng-deep h4.car-small-heading {\n      height: 40px;\n      line-height: 23px;\n    }\n\n    .wrapper-content {\n      padding: 20px 10px 40px;\n      clear: both;\n      float: left;\n      width: 100%;\n\n      &--tst {\n        width: 100% !important;\n      }\n    }\n\n    ::ng-deep.start-work {\n      max-width: 180px;\n\n      .product-box {\n        padding: 0;\n        border: none;\n        box-shadow: 10px 10px 10px -3px #676a6c;\n      }\n\n      @media only screen and (max-width:991px) {\n        max-width: unset;\n      }\n    }\n\n    ::ng-deep.product-imitation {\n      padding: 0px 5px;\n      max-height: 130px;\n      height: 130px;\n      vertical-align: middle;\n      text-align: center;\n      width: 100%;\n      color: #676a6c;\n      font-size: 18px;\n      font-family: \"MuseoSans-300\";\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      .product-desc {\n        padding: 0;\n      }\n\n      @media only screen and (max-width:991px) {\n        font-size: 16px;\n      }\n    }\n\n    .car-small-heading {\n      font-family: \"Marydale\";\n      font-size: 18px;\n\n      @media only screen and (max-width:991px) {\n        font-size: 15px;\n      }\n    }\n\n    @media only screen and (max-width:991px) {\n      padding: 30px;\n    }\n\n    @media only screen and (max-width:767px) {\n      padding: 20px 20px 40px;\n    }\n  }\n\n  &.lm-an-cards {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    position: relative;\n\n    .product-imitation {\n      background-color: #fff;\n      color: #676a6c;\n    }\n  }\n\n  .lm-an-cards__print {\n    position: absolute;\n    right: 16px;\n    // bottom: calc(100% - 30px);\n    top: -35px;\n\n    @media (max-width: 991px) {\n      right: 20px;\n    }\n  }\n\n  .car-small-heading {\n    color: #fff;\n  }\n\n  .practioner-dash-wrap--ss {\n    background: #F1F1F2;\n    border-radius: 6px;\n    color: #fff;\n    padding: 30px;\n  }\n\n  ::ng-deep.start-work__cell {\n\n    .product-imitation {\n      background-color: #fff;\n      color: #676a6c;\n    }\n  }\n}\n\n\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, .9);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: none;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100vh;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n  animation: blink 2s linear infinite;\n  opacity: 0;\n}\n\n#Path_130 {\n  animation: blink 2s linear infinite;\n  animation-delay: .5s;\n  opacity: 0;\n}\n\n#Path_132 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1s;\n  opacity: 0;\n}\n\n#Path_131 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1.5s;\n  opacity: 0;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n\n}\n\n.lm-slide-view {\n  padding-top: 20px;\n}\n\n.presnter-lm {\n  display: block;\n\n  &__flx {\n    display: none;\n  }\n\n  .map-heading {\n    margin-top: 0;\n  }\n\n  .wrap-all-boxes {\n    display: block;\n    max-width: 710px;\n    margin: 0 auto 50px;\n\n    &--ccltst {\n      max-width: 100%;\n    }\n\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
